import {Stack, useTheme} from '@mui/material';
import React, {Fragment, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import hapvidaMoreSearch from 'presentation/assets/images/hapvida-more-search.svg';
import {HighlightedText} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {SelectCardGrid, SelectCardList, StyledButton} from './styles';
import {MostSearchedCardProps} from './types';
import {useHostName} from 'presentation/hooks';
import {SpecialtyDetailsDrawer} from '../../../SpecialtyDetailsDrawer';
import Icon from 'presentation/icons';

const {findOutMore} = translations['pt-br'].commons;

export function MostSearchedCard({
	selected,
	text,
	handleClick,
	dataTagId,
	specialtyCode,
	showSpecialtyDetailsButton,
	...cardProps
}: MostSearchedCardProps) {
	const [searchParams] = useSearchParams();
	const {colors} = useTheme();
	const {isNotredameSaude} = useHostName();
	const [openDetailsDrawerState, setOpenDetailsDrawerState] = useState(false);
	const query = searchParams.get('q') || '';

	const handleOpenDetailsDrawer = (e?: React.MouseEvent<HTMLButtonElement>) => {
		e?.stopPropagation();
		setOpenDetailsDrawerState(true);
	};

	const handleCloseDetailsDrawer = () => {
		setOpenDetailsDrawerState(false);
	};

	return (
		<Fragment>
			<SelectCardList
				{...cardProps}
				elevation={0}
				selected={selected}
				sx={{cursor: 'pointer'}}
				style={{
					backgroundImage: isNotredameSaude ? 'none' : `url("${hapvidaMoreSearch}")`,
				}}>
				<SelectCardGrid onClick={handleClick} data-tag-id={dataTagId}>
					<Stack gap={0.5}>
						<HighlightedText
							text={text}
							highlight={query}
							dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT}
						/>

						{showSpecialtyDetailsButton ? (
							<StyledButton
								data-tag-id={
									AppointmentBookingEnum.CLICK_SABER_MAIS_DESCRICAO_ESPECIALIDADE
								}
								variant="text"
								size="small"
								onClick={handleOpenDetailsDrawer}>
								{findOutMore}
							</StyledButton>
						) : null}
					</Stack>
					<Icon
						name="arrow-right"
						size={24}
						color={selected ? colors.light.success.main : colors.brand.primary.blue}
					/>
				</SelectCardGrid>
			</SelectCardList>

			{openDetailsDrawerState ? (
				<SpecialtyDetailsDrawer
					isOpen={openDetailsDrawerState}
					onClose={handleCloseDetailsDrawer}
					onOpen={handleOpenDetailsDrawer}
					specialtyName={text}
					specialtyCode={specialtyCode}
				/>
			) : null}
		</Fragment>
	);
}
